import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="w-64 bg-gray-800 text-white h-screen p-4">
      <h2 className="text-2xl font-bold mb-4">Admin Dashboard</h2>
      <nav>
        <ul>
          <li className="mb-2">
            <NavLink to="/admin/aha999/projects" activeClassName="text-blue-400" className="block p-2">
              Projects
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink to="/admin/aha999/projects/add" activeClassName="text-blue-400" className="block p-2">
              Add Project
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink to="/admin/aha999/" activeClassName="text-blue-400" className="block p-2">
              Home
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink to="/admin/aha999/about" activeClassName="text-blue-400" className="block p-2">
              About
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink to="/admin/aha999/contact" activeClassName="text-blue-400" className="block p-2">
              Contact
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
